import { Component } from '@angular/core';
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { IconComponent } from '@examdojo/core/icon';
import { CmsUrlParts } from '../cms/cms.model';

@Component({
  selector: 'exam-playground',
  standalone: true,
  imports: [RouterLink, RouterLinkActive, RouterOutlet, IconComponent],
  templateUrl: './playground.component.html',
  styleUrls: ['./playground.component.scss'],
})
export class PlaygroundComponent {
  protected readonly CmsUrlParts = CmsUrlParts;
}
